import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.7",
      d: "M16.666 7.916v-2.25c0-1.4 0-2.1-.272-2.635A2.5 2.5 0 0 0 15.3 1.938c-.534-.272-1.235-.272-2.635-.272H7.333c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093c-.272.535-.272 1.235-.272 2.635v8.667c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092c.535.273 1.235.273 2.635.273h4.333m0-9.167h-5m1.667 3.333H6.666m6.667-6.666H6.666M13.75 12.5a1.873 1.873 0 0 1 3.64.625c0 1.249-1.873 1.873-1.873 1.873m.024 2.5h.009"
    }, null, -1)
  ])))
}
export default { render: render }